import { render, staticRenderFns } from "./ModalPengajuanPembatalanMataUjiSertifikasi.vue?vue&type=template&id=18ceb679&"
import script from "./ModalPengajuanPembatalanMataUjiSertifikasi.vue?vue&type=script&lang=js&"
export * from "./ModalPengajuanPembatalanMataUjiSertifikasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports